<template>
  <div class="row">
    <div class="col-md-12">
      <div class="pt-10 pb-10">
        <div class="table-responsive">
          <table class="excel-table-2007">
            <thead>
              <tr>
                <th class="text-center established-width-200">{{ $t('total_request') }}</th>
                <th class="text-center established-width-200">{{ $t('total_invoices') }}</th>
                <th class="text-center established-width-200">{{ $t('total_checks') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">{{ getNumberFormat(totalRequest) }}</td>
                <td class="text-center">{{ total_global_invoices }}</td>
                <td class="text-center">{{ checksTotal }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="text-left" colspan="2">{{ $t('total_to_be_billed') }}: {{ getNumberFormat(totalInvoiced) }}</td>
                <td class="text-left">{{ $t('total_text_payable') }}: {{ getNumberFormat(getTotalPayable()) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <form @submit.prevent="createInvoice" @keydown="createInvoiceForm.onKeydown($event)">
        <alert-success :form="createInvoiceForm" :message="$t('info_updated')"></alert-success>

        <v-weirdo-table
          :columns="columnsCheck"
          :mutable="mutable"
          :rows="rowsChecks"
          :footers="footerPagesCheck"
          :inspeccion="inspeccion"
          :separateHouse="0"
          :typeTable="'cheques'"
          :forceAppearance="determinesInspectionAction(['forceInspectionTable'])"
          v-on:addExecutionEvent="determineTheAccountField"
          v-on:setMarkAsPaidTrue="setMarkAsPaidTrue"
          v-on:setMarkAsPaidFalse="setMarkAsPaidFalse"
        ></v-weirdo-table>

        <v-button
          :disabled="!inspectionWithVerificationFiles"
          :loading="createInvoiceForm.busy"
        >{{ $t('save') }}</v-button>
      </form>

      <div v-if="checks && checks.length > 0" class="table-responsive">
        <table class="excel-table-2007 fixed-width-table table-hover">
          <thead class="thead-light-blue">
            <tr>
              <th class="text-center established-width-100">{{ $t('check_number') }}</th>
              <th class="text-center established-width-100">{{ $t('file') }}</th>
              <th class="text-center established-width-100">{{ $t('actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(bill, index) in checks" :key="`checks-tr-${index}`">
              <td class="text-center established-width-100">
                <template v-if="(bill.files.length > 0) && (getFirstOccurrence([2, 5], bill.tipo_pago_banco_id))">{{ bill.numero_cheque }}</template>
                <template v-else-if="(bill.files.length > 0) && (!getFirstOccurrence([2, 5], bill.tipo_pago_banco_id))">{{ checkVariable(bill.bancos) && isArray(bill.bancos) && bill.bancos.length > 0 ? getTheFirst(bill.bancos).numero : '' }}</template>
              </td>
              <td class="text-center established-width-100">
                <template v-if="bill.files.length > 0">
                  <div
                    v-for="(file, billIndex) in bill.files"
                    :key="`checks-div-${billIndex}`"
                  >
                    <template v-if="determinesInspectionAction(['export'])">
                      <a
                        :href="`/api/files/export_file/${file.id}?token=${authToken}`"
                        :title="`${file.nombre_original}`"
                        target="_blank"
                      >
                        <icon name="file-pdf" size="fa-1x"></icon>
                        {{ file.nombre_original }}
                      </a>
                    </template>
                    <template v-else>
                      {{ file.nombre_original }}
                    </template>
                  </div>
                </template>
              </td>
              <td class="text-center established-width-100">
                <template v-if="bill.files.length > 0 && determinesInspectionAction(['deleteRequestFile'])">
                  <div
                    v-for="(file, billIndex) in bill.files"
                    :key="`checks-div-${billIndex}`"
                  >
                    <button
                      type="button"
                      class="btn btn-link"
                      v-on:click="deleteCheckFile(file)"
                    >
                      <icon name="trash" size="fa-1x"></icon>
                      {{ $t('delete_file') }}
                    </button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Form from 'vform'

import {
  ignoreNonEditableItems,
  getTotalInvoiceAndCheck,
} from '../pages/all_contracts/contractService'
import IncludeHelperComponent from '../plugins/includeHelperComponent'

let newTime = null

export default {
  name: 'check-component',
  extends: IncludeHelperComponent,
  props: {
    billType: {
      type: String,
      required: true,
    },
    idRelationship: {
      type: Number,
      required: true,
    },
    records: {
      type: Array,
      default: () => {
        return []
      },
    },
    totalRequest: {
      type: Number,
      default: () => {
        return 0
      },
    },
    inspeccion: {
      type: Boolean,
      default: false,
    },
    provider: {
      type: Object,
      default: null,
    },
    projectBank: {
      type: Object,
      default: null,
    },
    projectId: {
      type: Number,
      default: null,
    },
    inspectionStartDate: {
      type: String,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      checks: [],
      rowsChecks: [],
      mutable: false,
      totalInvoiced: 0,
      createInvoiceForm: new Form({
        id: 0,
        checks: null,
        id_relationship: null,
      }),
    }
  },
  computed: {
    ...mapGetters([
      'authToken',
      'typePayments',
      'total_global_invoices',
      'bankPaymentTypes',
      'projectBankAccounts',
    ]),
    columnsCheck() {
      const type5 = this.getTheFirstOccurrenceByKey(this.checks, 5, 'tipo_pago_banco_id')
      if (this.checkVariable(type5)) {
        return this.columnsCheck5()
      }

      return this.columnsCheckTypeOtherThan5()
    },
    checksTotal() {
      const checkTotal = getTotalInvoiceAndCheck(this.rowsChecks, 'monto_cheque')
      this.$store.dispatch('getTotalGlobalChecks', checkTotal)

      return checkTotal
    },
    bankAccounts() {
      if (this.checkVariable(this.provider)) {
        const { bancos } = this.provider
        if (this.checkVariable(bancos)) {
          const banks = this.pluck(bancos, ['id', 'nombre'])

          return this.arrayCombineWith(banks, ['value', 'text'])
        }
      }

      return []
    },
    inspectionWithVerificationFiles() {
      const file = this.getTheFirstOccurrenceByKey(this.rowsChecks, 'file', 'type')
      if (this.checkVariable(file) && file.editable === true && file.id !== 0) {
        return true
      }

      return this.inspeccion
    },
    footerPagesCheck: function () {
      const type5 = this.getTheFirstOccurrenceByKey(this.checks, 5, 'tipo_pago_banco_id')
      const index = !this.checkVariable(type5) ? 4 : 3

      return this.footerTableChecks(this.columnsCheck.length, index)
    },
  },
  watch: {
    checksTotal: function () {
      this.getTotalInvoiced()
    },
    'total_global_invoices': function () {
      this.getTotalInvoiced()
    },
    records: function (records) {
      this.setDestroyed()
      this.setDestroyedCreateInvoiceForm()
      this.initializeAttributes()

      this.checks = this.initialFormatObjectsInvoicesAndChecks(records)
      const type5 = this.getTheFirstOccurrenceByKey(this.checks, 5, 'tipo_pago_banco_id')
      if (this.checkVariable(type5)) {
        this.getRowsTypePayment5(this.checks, this.typePayments)
      } else {
        this.getRowsCheckTypeOtherThan5(this.checks, this.typePayments)
      }
    },
  },
  beforeMount: function () {
    this.setDestroyed()
    this.setDestroyedCreateInvoiceForm()
  },
  mounted: function () {
    this.$nextTick(function () {
      this.$store.commit('GET_JIMP_START')
      this.initializeInvoicesAndChecks()
      this.initializeAttributes()
    })
  },
  methods: {
    async initializeAttributes() {
      await this.getProjectBankAccounts(this.projectId, true)
      await this.getBankPaymentTypes()
      await this.getTypePayments({ ignore_id: 5 })
      this.getTotalInvoiced()
      this.setRows()
    },
    initializeInvoicesAndChecks() {
      this.checks = this.initialFormatObjectsInvoicesAndChecks(this.records)
    },
    setRows() {
      const type5 = this.getTheFirstOccurrenceByKey(this.checks, 5, 'tipo_pago_banco_id')
      if (this.checkVariable(type5) && this.typePayments && this.typePayments.length > 0) {
        this.getRowsTypePayment5(this.checks, this.typePayments)
      } else if (!this.checkVariable(type5) && this.typePayments && this.typePayments.length > 0) {
        this.getRowsCheckTypeOtherThan5(this.checks, this.typePayments)
      }
    },
    columnsCheck5() {
      const columnsDefault = [
        'Tipo de pago',
        'Banco del cheque',
        'Número de cheque',
        'Monto cheque',
        'Fecha',
        'Archivo',
        'Comentario',
      ]

      return this.creationOfColumns(columnsDefault)
    },
    columnsCheckTypeOtherThan5() {
      const columnsDefault = [
        'Tipo de pago',
        'Concepto',
        { title: 'Cuenta origen', width: 250 },
        { title: 'Cuenta destino', width: 250 },
        'Monto',
        'Fecha',
        'Archivo',
        'Comentario',
      ]

      return this.creationOfColumns(columnsDefault)
    },
    getRowsTypePayment5(checks, typePayments) {
      const checkField = [
        'tipo_pago_id',
        'banco_cheque',
        'numero_cheque',
        'monto_cheque',
        'fecha',
        'file',
        'comentarios',
      ]
      const defaultValues = {
        tipo_pago_id: typePayments,
      }
      const keysForList = ['tipo_pago_id', 'file']
      this.getRowsChecks(checkField, checks, defaultValues, keysForList)
    },
    getRowsCheckTypeOtherThan5(checks, typePayments) {
      const checkField = [
        'tipo_pago_banco_id',
        'tipo_pago_id',
        'cuenta_proyecto_banco_id',
        'banco_id',
        'monto_cheque',
        'fecha',
        'file',
        'comentarios',
      ]
      const defaultValues = {
        tipo_pago_banco_id: {
          tag: 'select',
          runServer: false,
          value: this.bankPaymentTypes,
          useReferenceEvent: true,
        },
        tipo_pago_id: typePayments,
        cuenta_proyecto_banco_id: this.projectBankAccounts,
      }
      const keysForList = ['tipo_pago_banco_id', 'tipo_pago_id', 'cuenta_proyecto_banco_id', 'file']
      this.getRowsChecks(checkField, checks, defaultValues, keysForList)
    },
    determineTheAccountField(data, rows) {
      const newRows = this.createOptimizedObjectRequest(rows, data)
      this.remove(this.rowsChecks, event => {
        const result = this.getAllAssociatedValues(event, data.id, 'id')

        return this.checkVariable(result) && this.isArray(result) && result.length > 0
      })
      this.rowsChecks.push(newRows)
    },
    _markAsPaid(row, aprobado, text) {
      if (!this.determinesInspectionAction(['checkOrUncheck'])) {
        return
      }
      const index = this.findWith(row, val => {
        return this.checkVariable(val.id)
      })
      const model = row && row[index] ? row[index] : null
      if (this.checkVariable(model)) {
        this.setMarkAsPaid(`/api/checks/${model.id}/check_or_uncheck`, aprobado, text)
      }
    },
    setMarkAsPaidTrue(row) {
      this._markAsPaid(row, true, this.$t('title_mark_as_paid'))
    },
    setMarkAsPaidFalse(row) {
      this._markAsPaid(row, false, this.$t('title_mark_as_non_payment'))
    },
    async createInvoice() {
      try {
        this.createInvoiceForm.busy = true
        this.createInvoiceForm.id_relationship = this.idRelationship
        this.createInvoiceForm = this.handleTheLoadingOfInvoiceFiles(this.createInvoiceForm, this.rowsChecks)

        const createInvoiceForm = this.createBaseForm(this.createInvoiceForm)
        createInvoiceForm['checks'] = JSON.stringify(ignoreNonEditableItems(this.rowsChecks))

        const { data } = await this.postMethodShipping(createInvoiceForm, `/api/checks/${this.billType}`)

        this.createInvoiceForm.busy = false
        this.$store.dispatch(
          'setUpdateStatus',
          {
            tabla_referencia: this.billType,
            response: data,
            ...createInvoiceForm,
          },
        )
      } catch (error) {
        console.error(error)
        this.createInvoiceForm.busy = false
      }
    },
    async deleteCheckFile(model) {
      const promise = this.actionDeleteFile('/api/checks/file', model.id)
      this.actionDeleteThen(promise)
    },
    getTotalInvoiced() {
      const _this = this
      if (newTime !== null) {
        clearInterval(newTime)
      }
      const promise = new Promise (resolve => {
        newTime = setInterval(
          (totalGlobalInvoices) => {
            if (totalGlobalInvoices) {
              resolve(totalGlobalInvoices)
            }
          },
          500,
          _this.total_global_invoices,
        )
      })
      promise.then(response => {
        const totalGlobalInvoices = this.formattedValueRetracement(response)
        _this.totalInvoiced = totalGlobalInvoices - this.formattedValueRetracement(_this.checksTotal)
        clearInterval(newTime)
      })
    },
    getTotalPayable() {
      const totalRequest = this.formattedValueRetracement(this.totalRequest)
      const checksTotal = this.formattedValueRetracement(this.checksTotal)

      return (totalRequest - checksTotal)
    },
    setDestroyedCreateInvoiceForm() {
      this.createInvoiceForm = new Form({
        id: 0,
        checks: null,
        id_relationship: null,
      })
    },
    setDestroyed() {
      this.checks = []
      this.rowsChecks = []
      this.mutable = false
    },
  },
  destroyed: function () {
    this.$store.commit('GET_BANK_PAYMENT_TYPES_START')
    this.setDestroyed()
    this.setDestroyedCreateInvoiceForm()
  },
}
</script>
